<div class="main">
  <smt-header/>
  <div class="content-area">
  <router-outlet/>
  </div>
  <smt-footer/>
</div>
